import { CalculationType, type FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { CustomColumnField, MeasureField, MetricField } from "../../../../../../../../api/types/svTypes.ts";
import { DimensionFieldType } from "../../../../../../../../api/types/svTypes.ts";
import BlankZeroMenuItem from "../../common/fields/field-options/BlankZeroMenuItem.tsx";
import FreezeField from "../../common/fields/field-options/FreezeField.tsx";
import OtherOptionsWrapper from "../../common/fields/field-options/OtherOptionsWrapper.tsx";
import ReverseSignMenuItem from "../../common/fields/field-options/ReverseSignMenuItem.tsx";
import SuppressBlankValues from "../../common/fields/field-options/SuppressBlankValues.tsx";
import { isMeasureMeta } from "../../common/utilities/metaUtils.ts";
import PostFilteringMenuItem from "./PostFilteringMenuItem.tsx";

interface Props {
  field: MeasureField | MetricField | CustomColumnField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}
const FieldsOtherOptions = ({ field, saveChanges, readonly }: Props) => {
  const isCustomColumn = field.type === DimensionFieldType.CUSTOM;
  const isScalarMeasure = isMeasureMeta(field.meta) && field.meta.capabilities.isScalar;
  const isConditionCustomColumn = isCustomColumn && field.config.calculationType === CalculationType.ConditionValue;

  return (
    <OtherOptionsWrapper>
      {!isCustomColumn && <PostFilteringMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />}
      {!isScalarMeasure && !isConditionCustomColumn && (
        <>
          <BlankZeroMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
          <ReverseSignMenuItem field={field} saveChanges={saveChanges} readonly={readonly} />
        </>
      )}
      {!isConditionCustomColumn && (
        <SuppressBlankValues
          field={field}
          onChanged={saveChanges}
          showExcludeZeroValues={field.config.hideBlankValues === true}
          readonly={readonly}
        />
      )}
      <FreezeField field={field} readonly={readonly} />
    </OtherOptionsWrapper>
  );
};

export default FieldsOtherOptions;
